import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "uk-child-width-1-3@xl uk-child-width-1-3@l uk-child-width-1-2@m uk-child-width-1-2@s uk-grid-medium uk-grid-match",
  "data-uk-grid": ""
}
const _hoisted_2 = { class: "uk-card uk-card-default uk-card-body impx-padding-medium" }
const _hoisted_3 = { class: "uk-margin-remove-bottom uk-margin-small-top" }
const _hoisted_4 = { class: "uk-margin-remove-bottom uk-margin-small-top" }


  
export default /*@__PURE__*/_defineComponent({
  __name: 'RoomKeyItem',
  props: { roomSpec: Array },
  setup(__props) {

  const props =__props
  const commoditiesList = [
    {
      label: 'Wifi',
      icon: 'fa fa-wifi fa-2x',
      desc: 'Un wifi haut débit pour rester connecté.',
    },
    {
      label: 'Double chambre',
      icon: 'fa fa-door-closed fa-2x',
      desc: 'Deux chambres bien équipés.',
    },
    {
      label: 'Cuisine Moderne équipé',
      icon: 'fa fa-dumpster fa-2x',
      desc: 'Une Cuisine avec toutes les commodités.',
    },
    {
      label: 'Chauffe eau',
      icon: 'fa fa-wifi fa-2x',
      desc: 'Une Douche équipé d\'un de système de chauffe eau .',
    },
    {
      label: 'Tv',
      icon: 'fa fa-tv fa-2x',
      desc: 'Un écran Tv Plasma avec abonnement canal +.',
    },
    {
      label: 'Climatisation',
      icon: 'fa fa-fan fa-2x',
      desc: 'Une climatisation fonctionnel.',
    },
    {
      label: '2 Tv',
      icon: 'fa fa-tv fa-2x',
      desc: 'Deux écrans Tv Plasma pour chaque pièce avec abonnement canal +.',
    },
    {
      label: 'Deux douche',
      icon: 'fa fa-bathtub fa-2x',
      desc: 'Deux douches de haut standing pour chaque chambre avec toutes les commodités.',
    },
    {
      label: 'Une douche',
      icon: 'fa fa-bathtub fa-2x',
      desc: 'Une douches de haut standing avec toutes les commodités.',
    },
    {
      label: 'Salle de gym',
      icon: 'fa-heart fa-2x',
      desc: 'Un accès gratuit à une salle de gymnase bien équipée.',
    },
    {
      label: 'Petit-déjeuner',
      icon: 'fa fa-coffee fa-2x',
      desc: 'Un petit déjeuner offer.',
    },
    {
      label: 'Salle de jeu',
      icon: 'fa fa-child fa-2x',
      desc: 'Un espace pour les tout petit.',
    },
  ]
  const commodChoose = commoditiesList.filter(comm => props.roomSpec?.includes(comm.label))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commodChoose).slice(0, 6), (item, idx) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "uk-text-center",
        key: idx
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("i", {
            class: _normalizeClass(item.icon + ' impx-text-csa')
          }, null, 2),
          _createElementVNode("h6", _hoisted_3, _toDisplayString(item.label), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(item.desc), 1)
        ])
      ]))
    }), 128))
  ]))
}
}

})